import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Kullanici } from 'app/model/kullanici.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';
import {Observable} from 'rxjs/Observable';
import {GaleriModel} from '../model/spring-model/galeri.model';
import {UserModel} from '../model/spring-model/user.model';

@Injectable()
export class KullaniciService {

  public _kullaniciSubject: BehaviorSubject<Kullanici>;

  constructor(public http: HttpClient, private  authService: AuthenticationService) {
    this._kullaniciSubject = <BehaviorSubject<Kullanici>>new BehaviorSubject(undefined);
  }

  getKullanici(kullaniciPk: number): Observable<HttpResponse<UserModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'user/' + kullaniciPk;
    return this.http.get<UserModel>(apiURL, {observe: 'response' , headers: this.authService.getHeader()});
  }

  updateKullanici(kullanici: UserModel, oldPassword: string, newPassword: string): Observable<HttpResponse<UserModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'user/' + kullanici.id + '/op/' + oldPassword + '/np/' + newPassword;
    return this.http.get<UserModel>(apiURL, {observe: 'response' , headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/kullanici.service.ts